import PropTypes from 'prop-types';
import React from 'react';

import Grid from '@glass/web/components/base/Unstable_Grid2';
import { SM } from '@glass/web/modules/theme/breakpointKeys';
import makeStyles from '@glass/web/modules/theme/makeStyles';

import SearchSection from '@glass/shared/components/Section/SearchSection/SearchSection';

const useStyles = makeStyles()((theme) => ({
  container: {
    [theme.breakpoints.down(SM)]: {
      maxHeight: `32vh`,
      overflow: 'hidden',
    },
  },
}));

const ContentSection = React.forwardRef(
  (
    {
      onSearchSuccess,
      title,
      subtitle,
      isAlternatingColor,
      type,
      disableCta,
      spacing,
      items,
      children,
      ctaText,
      className,
    },
    ref,
  ) => {
    const { classes } = useStyles();
    return (
      <SearchSection
        ref={ref}
        className={className}
        ctaText={ctaText}
        disableCta={disableCta}
        isAlternatingColor={isAlternatingColor}
        spacing={spacing}
        subtitle={subtitle}
        title={title}
        type={type}
        onSearchSuccess={onSearchSuccess}
      >
        <Grid container className={classes.container}>
          {items}
        </Grid>
        {children}
      </SearchSection>
    );
  },
);

ContentSection.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  ctaText: PropTypes.string,
  disableCta: PropTypes.bool,
  isAlternatingColor: PropTypes.bool,
  items: PropTypes.node,
  onSearchSuccess: PropTypes.func,
  spacing: PropTypes.number,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  type: PropTypes.string,
};

ContentSection.defaultProps = {
  title: `$(verbWords.capitalized) <em>your</em> $(resumeWords.singular) <b>professionally</b> with $(brand.title)`,
  subtitle: `Use our recruiter-approved suggestions for free`,
};

ContentSection.displayName = 'ContentSection';

export default React.memo(ContentSection);
